import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import Button from '../button/Button';
import Cross from '../../assets/icons/cross.svg';

import { useModal } from '../../context/ModalContext';

import './HeadbandModal.scss';

export default function HeadbandModal() {
  const { closeModal } = useModal();

  return (
    <div className="headband-modal">
      <div className="close-container">
        <Cross
          className="close"
          width="28px"
          height="28px"
          onClick={() => closeModal()}
        />
      </div>

      <div className="beacon-container">
        <p>
          The
          {' '}
          <span className="highlight">Dreem 3S headband is available via Beacon Biosignals</span>
          {' '}
          for use in clinical trials and research. The device is now used to
          help develop treatments for people with neurological and psychiatric disease.
        </p>

        <p className="learn-more">
          Learn more at:
          {' '}
          <a href="https://beacon.bio/">beacon.bio</a>
        </p>
      </div>

      <div className="sunrise-container">
        <StaticImage className="sparkles" alt="sparkles" src="../../images/headbandModal/sparkles.png" />
        <StaticImage className="image" alt="sunrise" src="../../images/headbandModal/sunrise-picture.png" />

        <h4>A home sleep test that only needs...the tip of your chin!</h4>

        <p>
          Sleep testing can be tough (we know). That’s why we use Sunrise. Worn on the chin for
          1&#8209;2 nights, it’s precise comfortable, and FDA approved. It’s what helps us confirm a
          diagnosis; that’s important. We&nbsp;encourage you to learn more about it.
        </p>

        <Button
          text="Meet Sunrise"
          link="https://us.hellosunrise.com"
          displayArrow
          className="salmon large"
        />
      </div>
    </div>
  );
}
